import { TextField } from '@crehana/compass.ui';

import ModernModal, {
  TYPE_CONFIRM_BUTTON,
} from '@/views/AdminDashboard/components/ModernModal';

import type { IModalDeleteProps } from './types';

const ModalDelete: React.FC<IModalDeleteProps> = ({
  isOpen,
  onClose,
  disabled,
  onConfirm,
  value,
  textToConfirm,
  setTextConfirmation,
  titleLabel,
  descriptionLabel,
  cancelButtonLabel,
  deleteButtonLabel,
}) => {
  return (
    <>
      <ModernModal
        withHeader
        isOpen={isOpen}
        onClose={onClose}
        disableConfirmButton={disabled}
        onConfirm={onConfirm}
        title={titleLabel}
        typeConfirmButton={TYPE_CONFIRM_BUTTON.ALERT}
        labelCloseButton={cancelButtonLabel}
        labelConfirmButton={deleteButtonLabel}
      >
        <div className="tw-px-2">
          <p className="w-full tw-font-body4 mt-24 mx-auto mb-12 dark:tw-text-neutral-light-100">
            {descriptionLabel}
          </p>

          <TextField
            full
            value={value}
            inputElProps={{
              placeholder: textToConfirm,
              onChange: e => setTextConfirmation(e.target.value),
            }}
          />
        </div>
      </ModernModal>
    </>
  );
};

export default ModalDelete;
